var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"419be468210e104a5d6bc51132db3c48e8071de6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["supabase-app-staging@supabase"]={id:"419be468210e104a5d6bc51132db3c48e8071de6"};
      